import applePaySchema from './applePaySchema';

const makePaymentSchema = {
  ...applePaySchema,
  paymentAccountId: [{
    rule: 'required',
    error: 'A bank account must be selected',
  }],
};

export default makePaymentSchema;
